// extracted by mini-css-extract-plugin
export default {"nameInput":"name_nameInput__KLBdf","input":"name_input__kj3l7","active":"name_active__t89-z","slide-in-bottom":"name_slide-in-bottom__Env+g"};